<template lang="html">
  <div style="text-align: left;">
    <a href="https://www.lifeapps.com.br/contato" target="_blank">
      <img src="@/assets/BANNER_MODULOS_INTERNO.png" class="banner" />
    </a>
  </div>
</template>

<script>
export default {
  name: "MarketingModules"
};
</script>

<style lang="scss" scoped>
.banner {
  width: 100%;
  height: 100%;
  border-radius: 2em 2em 2em 2em / 2em 2em 2em 2em;
}
</style>
